
    // @ts-nocheck
    import { __internal_buildRpcClient } from "@blitzjs/rpc";
    export default __internal_buildRpcClient({
      resolverName: "getBookings",
      resolverType: "query",
      routePath: "/getBookings",
      httpMethod: "POST",
    });
  